import { Entidad } from "./entidad";

export class Propuesta {
  constructor(
    public IdPropuesta: number | string = '',
    public entidades: Entidad[] = <Entidad[]>[],
    public PropuestaNombre: string = '',
    public PropuestaEstado: number | string = '', //mmmmmm
  ) { }
}

export class EstadoPropuesta{
  constructor(
    public id: number | string = '',
    public descripcion: string = '',
    public orden?:number
  ){}
}
